export const POPUP_CONTENT = "popup_content";
export const SURVEY_CONTENT = "survey_content";
export const ONE_PANEL_SURVEY_CONTENT = "onepanelsurvey_content";
export const GATEKEEPER_CONTENT = "gatekeeper_content";
export const WALKTHROUGH_CONTENT = "walkthrough_content";

export const TOGGLE_SURVEY = "TOGGLE_SURVEY";
export const TOGGLE_ONE_PANEL_SURVEY = "TOGGLE_ONE_PANEL_SURVEY";
export const TOGGLE_IDLE = "TOGGLE_IDLE";
export const RESET = "RESET";
export const ADVANCE_SURVEY = "ADVANCE_SURVEY";
export const ADVANCE_ONE_PANEL_SURVEY = "ADVANCE_ONE_PANEL_SURVEY";
export const REVERT_SURVEY = "REVERT_SURVEY";
export const REVERT_ONE_PANEL_SURVEY = "REVERT_ONE_PANEL_SURVEY";
export const ON_CHANGE = "ON_CHANGE";
export const INIT = "INIT";
export const SET_RENDER = "SET_RENDER";
export const SHOW_SURVEY_COMPLETION = "SHOW_SURVEY_COMPLETION";
export const SHOW_ONE_PANEL_SURVEY_COMPLETION =
  "SHOW_ONE_PANEL_SURVEY_COMPLETION";
export const SHOW_AUTOPOP_UP = "SHOW_AUTOPOP_UP";
export const QUANTUM_METRICS_EVENT_LISTENERS = `window.onStart=function(){const qmReplay=QuantumMetricAPI.getReplay()};window.QuantumMetricAPI?QuantumMetricAPI.addEventListener("start",onStart):window.QuantumMetricOnload=function(){QuantumMetricAPI.addEventListener("start",onStart)};`;
export const MM_PRIVACY_URLS = [
  "/dashboard/Details/",
  "/myannuity/details/",
  "/password-redirect/",
  "/payments/",
  "/pensionannuity/forms/",
  "/pensionannuity/home/",
  "/pensionannuity/settings/",
  "/policyDetails/",
  "/reqloan/",
  "/resend-verify/",
  "/transactions/beneficiarychange/",
  "/transactions/cashvalue/",
  "/transactions/ownerchange/print/",
  "/transactions/status/",
  "/verify-redirect/",
];
